import React from "react";
import img1 from "./Images/section6leaftlogo.png";
import img2 from "./Images/section6rightlogo.png";

export default function Section6() {
  return (
    <div>
      <section class="sixth-heghlight-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="left-side-wrapper col-sm-12 col-md-6">
              <div class="left-side-container">
                <img src={img1} />
                <div class="description-wraper bold black">
                  <h6>
                    Welcome to the year of you.
                    <br />
                    Now all you need is iPhone.
                  </h6>
                </div>
                <div class="links-wrapper">
                  <ul>
                    <li>
                      <a href="">Learn more</a>
                    </li>
                    <li>
                      <a href="">
                        Try it free<sup>2</sup>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="right-side-wrapper col-sm-12 col-md-6">
              <div class="right-side-container">
                <div>
                  <img src={img2} />
                </div>
                <div class="description-wraper bold">
                  Get up to 3% Daily Cash back
                  <br />
                  with every purchase.
                </div>
                <div class="links-wrapper">
                  <ul>
                    <li>
                      <a href="">Learn more</a>
                    </li>
                    <li>
                      <a href="">Apply now</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
